var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { CustomizeTab } from '../components/tabs/CustomizeTab';
import { useFilterConfigStore } from '../store/filterConfigurationStore';
import { useFilterStore } from '../store/filterStore';
export var CustomizeFilterPageBody = function () {
    var _a = useState(0), activeTab = _a[0], setActiveTab = _a[1];
    var activeFilter = useFilterStore(function (state) {
        return Object.values(state.filters).find(function (filter) { return filter.active; });
    });
    var config = useFilterConfigStore(function (state) {
        var _a;
        if (!activeFilter)
            return null;
        return (_a = state.filterConfigurations[activeFilter.id]) !== null && _a !== void 0 ? _a : null;
    });
    var setFilterConfiguration = useFilterConfigStore(function (state) { return state.setFilterConfiguration; });
    var clearConfiguration = useFilterConfigStore(function (state) { return state.clearConfiguration; });
    var setEnabledModule = useFilterConfigStore(function (state) { return state.setEnabledModule; });
    if (!activeFilter) {
        return _jsx(Box, {});
    }
    return (_jsx(Box, { children: _jsx(Box, __assign({ sx: { mt: 2 } }, { children: _jsx(CustomizeTab, { readonly: false, extraComponent: _jsxs(Typography, __assign({ variant: "h6", color: "secondary" }, { children: [!(activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.description)
                            ? 'No description'
                            : activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.description, (activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.updatedOn)
                            ? " (updated: ".concat(new Date(activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.updatedOn).toLocaleDateString(), ")")
                            : null, !activeFilter ? 'Select a Filter' : null, _jsx(Typography, __assign({ variant: "caption", color: "text.secondary", sx: { ml: 1 } }, { children: (activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.importedOn)
                                ? "Imported on ".concat(new Date(activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.importedOn).toLocaleDateString())
                                : null }))] })), filter: activeFilter, config: config, onChange: function (config) {
                    setFilterConfiguration(activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.id, config);
                }, clearConfiguration: function (filterId, macroNames) {
                    clearConfiguration(filterId, macroNames);
                }, setEnabledModule: setEnabledModule }) })) }));
};
